import React, { useState } from 'react';
import { Box, Paper, Typography, Stack, Tabs, Tab } from '@mui/material';
import ShortAbsenceApprovalQueue from './ShortAbsenceApprovalQueue';
import ShortAbsenceMap from './ShortAbsenceMap';
import DepartmentSelector from '../DepartmentSelector';

export default function ShortAbsenceApprovalsPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [departmentId, setDepartmentId] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleActionSuccess = () => {
    setRefreshKey(k => k + 1);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5">Short Absence Approvals</Typography>
        <DepartmentSelector
          value={departmentId}
          onChange={setDepartmentId}
          showAll
          size="small"
          sx={{ minWidth: 200 }}
        />
      </Stack>

      <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} sx={{ mb: 2 }}>
        <Tab label="Pending Approvals" />
        <Tab label="Team Map" />
      </Tabs>

      {tabIndex === 0 && (
        <Paper sx={{ p: 2 }}>
          <ShortAbsenceApprovalQueue
            key={refreshKey}
            departmentId={departmentId}
            onActionSuccess={handleActionSuccess}
          />
        </Paper>
      )}

      {tabIndex === 1 && (
        <Paper sx={{ p: 2 }}>
          <ShortAbsenceMap
            departmentId={departmentId}
            refreshTrigger={refreshKey}
          />
        </Paper>
      )}
    </Box>
  );
}

